import PropTypes from 'prop-types';
import TrainerSocialAction from './TrainerSocialAction';

const propTypes = {
  url: PropTypes.string.isRequired,
};

export default function TrainerSocialLinkedIn({ url }) {
  return <TrainerSocialAction url={url}>LinkedIn</TrainerSocialAction>;
}

TrainerSocialLinkedIn.propTypes = propTypes;
